// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ButtonToMap_wrapper__3TtlU","title":"ButtonToMap_title__5kT7B"};